<template>
    <div id="app">
        <transition name="fade">
            <Welcome 
                v-if="sceneState === SCENE_STATES.get('dormant')"
                v-show="mounted"
                @beginClicked="loadScene"/>
        </transition>
        <transition name="fade">
            <Loading v-if="sceneState === SCENE_STATES.get('loading')"/>
        </transition>
        <transition name="fade">
            <SceneContainer
                v-if="sceneState !== SCENE_STATES.get('dormant')"
                v-show="sceneState === SCENE_STATES.get('ready')"
                @loaded="onSceneLoaded"/>
        </transition>  
    </div>
</template>

<script>
    import Vue from 'vue';
    import Welcome from './components/Welcome.vue';
    import Loading from './components/Loading.vue';

    const SCENE_STATES = new Map([
        ['dormant', 1],
        ['loading', 2],
        ['ready', 3],
    ]);

    export default Vue.extend({
        name: 'app',
        components: {
            Welcome,
            Loading,
            SceneContainer: () => import('./components/SceneContainer.vue'),
        },
        data: () => ({
            SCENE_STATES,
            beginClicked: false,
            sceneState: SCENE_STATES.get('dormant'),
            mounted: false,
        }),
        methods: {
            loadScene() {
                this.beginClicked = true;
                this.sceneState = SCENE_STATES.get('loading');
            },
            onSceneLoaded() {
                this.sceneState = SCENE_STATES.get('ready');
            },
        },
        mounted() {
            this.mounted = true;
        },
    });
</script>

<style>
    .fade-enter-active {
        transition: opacity 3s;
    }

    .fade-leave-active {
        transition: opacity 2s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>

